import { useLanguage } from '@languages/index';

interface CampaignFormModificationGuideProps {
  className?: string;
}

const CampaignFormModificationGuide = ({
  className,
}: CampaignFormModificationGuideProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };

  return (
    <p
      className={`w-full pt-[11px] px-[10px] pb-[14px] bg-[#1DCD00] bg-opacity-10 border border-[#1DCD00] text-[#1DCD00] text-[14px] text-center font-bold ${className}`}
    >
      {languageTexts.campaign_form_modification_guide}
    </p>
  );
};

export default CampaignFormModificationGuide;
